import loadable from '@loadable/component';

export const OrgDashboardPaymentSummaryPageLoadable = loadable(
  () => import('./OrgDashboardPaymentSummaryPage'),
  {
    resolveComponent: (module) => module.OrgDashboardPaymentSummaryPage,
  },
);
